/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Card category
 */
export interface CardCategoryApiModel {
  /**
   * Card category ID
   */
  id?: string;
  /**
   * URL of batch image
   */
  image?: string;
  /**
   * Card category title
   */
  title?: string;
  /**
   * Category type (readonly)
   */
  type?: CardCategoryApiModelTypeEnum;
}
export enum CardCategoryApiModelTypeEnum {
  Base = 'base',
  Custom = 'custom'
}
